import React, { Component } from "react";
import { Button,Container,Row,Col,Form } from 'react-bootstrap'
import "./login.css";
import Countdown from 'react-countdown';
import ReactCodeInput from 'react-verification-code-input';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from "react-router-dom";
import { render } from "@testing-library/react";

import Countdowncode from "./countdowncode.page";

var md5 = require('md5');


class LoginPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showInsertPassword: false,
      step: 0,
      id_member: '',
      inputUser: '',
      canSend: false,
      timeDown: (Date.now() + 30000),

      stepValidateCodeConfirm: false,
      codeUserConfirm: '',
      stepValidateData: '',
      confirmNumbEmail: '',
      leyendValidateCode: '',
      timeDownCode : ''
    }

  }

  componentDidMount() {
    if(typeof localStorage.t_id_tkn !== 'undefined') {
      if(localStorage.t_id_tkn !== '') {
        //Verificando si existe una sesión
        const data = { tkn: localStorage.t_id_tkn, }
        fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=getValidateSession", this.headersPOST({ ...data }))
        .then(response => response.json())
        .then((response) => {
          if(response.status === 'ok') {
            this.props.initsetState({ app_id_s: response.login })
            this.props.history.push('/');
          } else {
            this.setState({ step: 1, })
          }
        })
      } else {
        this.setState({ step: 1, })
      }
    } else {
      this.setState({ step: 1, })
    }
  }


  render() {
    const { formNewPassword, showInsertPassword, step, codeUserConfirm, } = this.state;

    if(step === 1) {
      return (
        <div>
            <Container>
                <Row>
                    <Col xs={12} style={{textAlign:'center'}}>
                      <img style={{width:'250px', objectFit: 'contain'}} src={"/img/profile-id.png"} />
                    </Col>
                    <Col xs={12} md={{span:6,offset:3}} lg={{span:4,offset:4}} style={{marginTop:'35px'}}>

                      <Form.Group controlId="formLogin">
                        <Form.Label style={{color:'#259DB4',fontWeight:'500'}}>Tu correo electrónico o tarjeta.id</Form.Label>
                        <Form.Control onChange={(event) => { this.setState({ inputUser: event.target.value }) }} type="text" placeholder="tarjeta.id/mb ó mi@correo.com" className="input__login"/>
                      </Form.Group>

                      <Form.Group>
                        <Button block className="btn__login" id="btnLogin" onClick={() => { this.onValidateUsername() }}>Continuar</Button>
                      </Form.Group>
                      <Form.Group>
                        <div style={{textAlign:'right'}}>
                          <p>¿Aún no tienes tu tarjeta.id?</p>
                          <a href="https://mi.tarjeta.id/" className="link__login">Haz clic aquí</a>
                        </div>
                      </Form.Group>

                    </Col>
                    <Col xs={12} style={{textAlign:'center'}}>
                      <img style={{width:'130px',height:'86px'}} src={"/img/wsoft.png"} />
                    </Col>
                </Row>
            </Container>
        </div>
      );
    }

    if(step === 2) {
      return (
        <div>
          <Container>
            <Row>
                <Col xs={12} style={{textAlign:'center'}}>
                  <img style={{width:'250px', objectFit: 'contain'}} src={"/img/profile-id.png"} />
                </Col>
                <Col xs={12} md={{span:6,offset:3}} lg={{span:4,offset:4}} style={{marginTop:'35px'}}>
                  <Form.Group controlId="formLogin">
                    <Form.Label style={{color:'#259DB4',fontWeight:'500'}}>Verificando...</Form.Label>
                  </Form.Group>
                </Col>
                <Col xs={12} style={{textAlign:'center'}}>
                  <img style={{width:'130px',height:'86px'}} src={"/img/wsoft.png"} />
                </Col>
            </Row>
          </Container>
        </div>
      );
    }

    if(step === 3) {
      const { stepValidateData, stepValidateCodeConfirm, codeUserConfirm, } = this.state
      const { perfil, nombre, } = this.state.arr
      const URI = `https://tarjeta.id/${perfil}`

      return (
        <div>
          <Container>
            <Row>
              <Col xs={12} style={{textAlign:'center'}}>
                <img style={{width:'250px', height:'250px', objectFit: 'cover', borderRadius: '100%', }} src={URI} />
              </Col>
              <Col xs={12} md={{span:6,offset:3}} lg={{span:6,offset:3}} style={{marginTop:'10px'}}>
                <Form.Group controlId="formLogin">
                  <p style={{ textAlign: 'center', fontWeight:'500', fontSize: '2rem', }}>¡Hola {nombre}!</p>
                </Form.Group>

                {
                  (!stepValidateCodeConfirm && stepValidateData === '') ? (
                    <Row>
                      <Col xs={8}>
                        <Form.Group controlId="formLogin">
                          <Form.Label style={{color:'#259DB4',fontWeight:'500'}}>Contraseña<a href=""></a></Form.Label>
                          <Form.Control onChange={(e) => { this.setState({ inputPass: e.target.value, }) }} type="password" placeholder="Introduce tu contraseña" />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="formLogin">
                          <Form.Label style={{color:'#259DB4',fontWeight:'500', opacity: 0,}}>.<a href=""></a></Form.Label>
                          <Button block className="btn__login" id="btnLogin" onClick={() => { this.setValidateFromPassword() }}>Acceder</Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : null
                }

                { !stepValidateCodeConfirm ? this.makeButtonsActions() : null}

                {
                  stepValidateCodeConfirm ? (
                    <div style={{textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                      <ReactCodeInput
                        fields={4}
                        onChange={(e) => { this.setState({codeUserConfirm: e}, this.compareIsCodeComplete) }}
                      />

                      { codeUserConfirm === 4 ? <p>Validando código...</p> : null }

                      <Countdowncode />
                    </div>
                  ) : null
                }

              </Col>
              <Col xs={12} style={{textAlign:'center'}}>
                <img style={{width:'130px',height:'86px'}} src={"/img/wsoft.png"} />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return ( <p></p> )
  }

  setValidateFromPassword() {
    const data = { id_member: this.state.arr.id_member, password: this.state.inputPass, }
    fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=setValidatePassword", this.headersPOST({ ...data }))
    .then(response => response.json())
    .then((response) => {
      if(response.status === 'error') {
        alert('La contraseña introducida es inválida, intentalo nuevamente')
        this.setState({ inputPass: '', })
      } else {
        //Redirección wuuuu
        localStorage.setItem('t_id_tkn', response.login);
        window.location.reload()
      }
    }).catch((error) => console.info(error));
  }

  compareIsCodeComplete() {
    if(this.state.codeUserConfirm.length === 4) {
      //Se desbloquea
      const data = { code: this.state.codeUserConfirm, }
      fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=setValidateCode", this.headersPOST({ ...data }))
      .then(response => response.json())
      .then((response) => {
        if(response.status === 'error') {
          alert('El código introducido es inválido, intentalo nuevamente')
          this.setState({ codeUserConfirm: '', })
        } else {
          //Redirección wuuuu
          localStorage.setItem('t_id_tkn', response.login);
          window.location.reload()
        }
      }).catch((error) => console.info(error));
    } else {
      //Se oculta
    }
  }

  makeButtonsActions() {
    const { canSend, arr, stepValidateData, confirmNumbEmail, leyendValidateCode, } = this.state

    return (
      <>
        {
          arr.withFacebook ? (
            <Form.Group>
              <Button block className="btn__login" id="btnLogin" onClick={() => {
                window.location = 'https://m.me/tarjeta.id?ref=validar_sesion'
              }}>Ingresar con mi cuenta de Facebook</Button>
            </Form.Group>
          ) : null
        }

        <hr />

        {
          stepValidateData !== '' ? (
            <>
              <Form.Group>
                <Row>
                  <Col xs={"12"}>
                    <Button style={{marginBottom:'20px'}}
                    onClick={
                      (e) => {
                        this.setState({step:3,stepValidateData:''})
                      }
                    }
                    >Atrás</Button>
                  </Col>
                  <Col xs={"12"}>
                    <Form.Group controlId="formLogin">
                      <Form.Label style={{color:'#259DB4',fontWeight:'500'}}>
                        <p>Valida tu {stepValidateData === 'email' ? 'correo electrónico' : `número de ${stepValidateData}`}</p>
                      </Form.Label>
                      <Form.Control value={confirmNumbEmail} type={`${stepValidateData === 'email' ? 'email' : 'text'}`}
                      placeholder={
                        ( stepValidateData === 'sms' ? arr.withSMS : ( stepValidateData === 'email' ? arr.withEmail : arr.withWhatsapp ) )
                      }
                      onChange={(e) => { this.validatePhone(e,stepValidateData) }} />
                    </Form.Group>
                  </Col>
                </Row>
              </Form.Group>


              <Form.Group>
                <Button block className={`btn__login btn-primary`} onClick={() => { this.onSendCodeByService() }}>Recibir código</Button>
              </Form.Group>

              <p>{ leyendValidateCode }</p>

            </>
          ) : (
            <>
              <Form.Group>
                <Row>
                  <Col md={8}>
                    <p>OTRO MÉTODO DE AUTENTICACIÓN EN:</p>
                  </Col>
                  <Col md={4} className={'ws-countdown'}>
                    <Countdown
                      date={this.state.timeDown}
                      daysInHours={false}
                      zeroPadDays={0}
                      precision={3}
                      onComplete={() => {
                        this.setState({canSend: true,})
                      }}
                    />
                  </Col>
                </Row>
              </Form.Group>
              
              <Row>
                <Col xs={"12"} lg={"6"}>
                  <Form.Group>
                    <Button block disabled={ (canSend) ? false : true } className={`btn__login btn-${!canSend ? 'secondary' : 'primary'}`} id="btnLogin" onClick={() => {  if(canSend) { this.onSendCodeByService('email') } }}>Ingresar por correo</Button>
                  </Form.Group>
                </Col>
{/* 
                <Col xs={"12"} lg={"6"}>
                  <Form.Group>
                    <Button block disabled={ (canSend) ? false : true } className={`btn__login btn-${!canSend ? 'secondary' : 'primary'}`} id="btnLogin" onClick={() => { if(canSend) { this.onSendCodeByService('whatsapp') } }}>Ingresar por Whatsapp</Button>
                  </Form.Group>
                </Col> */}

                <Col xs={"12"} lg={"6"}>
                  <Form.Group>
                    <Button block disabled={ (canSend) ? false : true } className={`btn__login btn-${!canSend ? 'secondary' : 'primary'}`} id="btnLogin" onClick={() => { if(canSend) { this.onSendCodeByService('sms') } }}>Ingresar por SMS</Button>
                  </Form.Group>
                </Col>
              </Row>  
            </>
          )
        }
      </>
    )
  }

  onSendCodeByService(type) {
    let { stepValidateData, confirmNumbEmail, arr, } = this.state
    let { md_withEmail, md_withWhatsapp, md_withSMS, username, id_member, } = arr
    console.log(type)
    if(stepValidateData === '') {
      //No ha validado algún método
      stepValidateData = type;
      this.setState({ stepValidateData })
      return false
    } else {
      let flag = false,
      type = stepValidateData

      if(type === 'sms') {
        if(md5(confirmNumbEmail) === md_withSMS)
          flag = true;

      } else if(type === 'whatsapp') {
        if(md5(confirmNumbEmail) === md_withWhatsapp)
          flag = true;
      } else if(type === 'email') {
        if(md5(confirmNumbEmail) === md_withEmail)
          flag = true;
      }

      if(flag) {
        this.setState({ canSend: false, leyendValidateCode: '', })
        const { nombre, } = this.state.arr

        const data = { type, id_member, username, nombre, }
        fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=setNewCodeID", this.headersPOST({ ...data }))
        .then(response => response.json())
        .then((response) => {
          this.setState({
            stepValidateCodeConfirm: true,
          })
        }).catch((error) => console.info(error));
      } else {
        this.setState({
          leyendValidateCode: 'Lo sentimos, el código no es válido',
        })
      }

    }

  }

  onValidateUsername() {
    const { inputUser } = this.state
    const data = {
      step: 1,
      inputUser
    }
    this.setState({step: 2,})
    fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=validateInfoIDMember", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      if(response.oauth == 0) {
        this.setState({ step: 1, })
        alert('Lo sentimos, no pudimos encontrar esta tarjeta. Por favor contacta a soporte.')
      } else {
        this.setState({ ...response, step: 3, })
      }
    }).catch((error) => console.info(error));


  }

  //Validar Teléfono
  validatePhone(event,type){

    if(type==="sms" || type==="whatsapp"){
      const val = event.target.value;
      let content = [];
      Array.from(val).map(letter=>{
        if (/\D/g.test(letter)) letter = letter.replace(/\D/g, '');
        if(!isNaN(letter)) {
          content.push(letter);
        }
      });
      let string = content.join("");
      this.setState({
        confirmNumbEmail: string.trim()
      })
    }else{
      this.setState({
        confirmNumbEmail: event.target.value
      })
    }
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  initState(param) {
    this.props.initsetState(param)
    return true
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }


};

export default withRouter(LoginPage)